import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1rxnwwatsq: FaireBrandEntity = {
  token: "b_1rxnwwatsq",
  type: "brand",
  name: "PATCH - Eco First Aid",
  avatarUrl:
    "https://cdn.faire.com/fastly/d14aaaac1cb7dbd1eae723b8164d06dd49abbf375e53eca07babecd2c50833dc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e0d03df11c7b15abc5d03427cf8bb1a5673517ffa421189de88b3be7e48730a8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d14aaaac1cb7dbd1eae723b8164d06dd49abbf375e53eca07babecd2c50833dc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e0d03df11c7b15abc5d03427cf8bb1a5673517ffa421189de88b3be7e48730a8.jpeg",
  location: "VA, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 29,
  isInsider: true,
  description:
    "We care deeply about people and the environment, so we combined the two to create Patch. It's our way of bringing natural and organic choices to the consumer market. Why... because the world needs cleaner, more natural innovations to combat our environmental, health and wellness challenges.\n\nSo after months of intense product development, enter PATCH natural bamboo bandages. Why Bamboo? Well, non-toxic and sustainable bamboo is both human and planet friendly, providing an alternative to most commonly used materials. Our products exist as a solution for skin sensitivities, as well as a better option for the environment. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.519Z",
    importedBy: "entity-db-cli",
  },
};
